export function setFocusToHTMLElement(htmlElementId: string): void {
	const htmlElement = document.getElementById(htmlElementId);
	if (htmlElement instanceof HTMLElement) {
		htmlElement.focus();
	}
}

export function setFocusToElementIfAllowed(htmlelement: HTMLElement) {
	for (let element = document.activeElement; element; element = element.parentElement) {
		if (element.getAttribute("data-role") === "toast") {
			return;
		}
	}
	htmlelement.focus();
}
